export default[
    {
        path: "/user/index",
        name: "UserHome",
        props: true,
        component: () => import(/* webpackChunkName: "user" */"../views/User/Index/index.vue"),
        meta: {
            title: "我的",
            showloading: true,
            requiresAuth: true
        }
    },
    {
        path: "/user/edit",
        name: "UserEdit",
        props: true,
        component: () => import(/* webpackChunkName: "user" */"../views/User/Edit/index.vue"),
        meta: {
            title: "信息修改",
            showloading: true,
            requiresAuth: true
        }
    },
    {
        path: "/user/entry-record",
        name: "EntryRecord",
        props: true,
        component: () => import(/* webpackChunkName: "user" */"../views/User/EntryRecord/index.vue"),
        meta: {
            title: "我的活动",
            showloading: true,
            requiresAuth: true
        }
    }
];
